import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import stores from '../app/stores';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    $http: axios,
    applicationLoading: true,
  },
  mutations: {
    /**
     * Set application was loading, defining the applicationLoading
     * property in state with true value.
     *
     * @param state
     */
    applicationWasLoading(state) {
      state.applicationLoading = true;
    },

    /**
     * Set application wasn't loading, defining the applicationLoading
     * property in state with false value.
     *
     * @param state
     */
    applicationWasNotLoading(state) {
      state.applicationLoading = false;
    },
  },
  actions: {
  },
  modules: {
    ...stores,
  },
});
